import Main from "./utilities/Main";


function App() {
  return (
    <div>
      <Main />
    </div>
  );
}

export default App;
